module.exports = __webpack_public_path__ + "static/media/4.39998ddc.jpg";